import { Component, Input, OnInit } from "@angular/core"

import { DisplayService } from "../display.service"
import { Merchant } from "../shared/merchant"
import { MerchantReferralCampaignPagesColors } from "../shared/merchant-referral"

@Component({
  selector: "app-merchant-info",
  templateUrl: "./merchant-info.component.html",
  styleUrls: ["./merchant-info.component.scss"]
})
export class MerchantInfoComponent implements OnInit {
  @Input() merchant: Merchant
  @Input() colors: MerchantReferralCampaignPagesColors

  text_color: string
  icon_color: string

  constructor(private displayService: DisplayService) {}

  ngOnInit() {
    this.text_color = this.displayService.getOffsetColor(this.colors.background, 50)
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/merchant-info/merchant-info.component.ts